import React, { FC } from "react"

import { 
    AppstoreOutlined, 
    LikeOutlined, 
    DislikeOutlined, 
    LoadingOutlined,
    PhoneOutlined,
    PercentageOutlined
} from "@ant-design/icons"
import { Spin } from "antd"

import { ITableBanners } from "../../../../redux/slices/ads/types"

interface IProps {
    bannerData: ITableBanners
    isLoading: boolean
}

const AdsBanners: FC<IProps> = ({ bannerData, isLoading }) => {
    return (
        <Spin spinning={isLoading} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
            <div className="ads-banners">
                <div className="banner-card">
                    <div className="banner-title">Всего объявлений</div>
                    <div className="banner-value">
                        <AppstoreOutlined />
                        {bannerData.total}
                    </div>
                </div>
                <div className="banner-card">
                    <div className="banner-title">Наших квартир</div>
                    <div className="banner-value positive">
                        <LikeOutlined />
                        {bannerData.answered}
                    </div>
                </div>
                <div className="banner-card">
                    <div className="banner-title">Не снял</div>
                    <div className="banner-value negative">
                        <DislikeOutlined />
                        {bannerData.unanswered}
                    </div>
                </div>
                <div className="banner-card">
                    <div className="banner-title">Не первые</div>
                    <div className="banner-value negative">
                        <DislikeOutlined />
                        {bannerData.not_first}
                    </div>
                </div>
                <div className="banner-card">
                    <div className="banner-title">Не дозвонился</div>
                    <div className="banner-value negative">
                        <PhoneOutlined />
                        {bannerData.not_call}
                    </div>
                </div>
                <div className="banner-card">
                    <div className="banner-title">Конверсия</div>
                    <div className="banner-value">
                        <PercentageOutlined />
                        {bannerData.conversion}
                    </div>
                </div>
            </div>
        </Spin>
    )
}

export default AdsBanners